import '../../Label/style';
import './index.scss';
